module.exports = __webpack_public_path__ + "img/archive-tick.b97d73e7.svg";